import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReferralsComponent } from './referrals/referrals.component';
import { OwnerDashboardComponent } from './ownerdashboard/ownerdashboard.component';
import { AppLayoutComponent } from './_layout/app-layout/app-layout.component';
import { LoginComponent } from './auth/login.component';
import { UpdateProfileComponent } from './tenant-dashboard/update-profile/update-profile.component';
import { RoomAllocAndProfileComponent } from './tenant-dashboard/room-alloc-and-profile/room-alloc-and-profile.component';
import { TenantDashboardComponent } from './tenant-dashboard/dashboard/dashboard.component';
import { GoldenPropertiesComponent } from './golden-properties/golden-properties.component';
import { PropertyDetailComponent } from './property-detail/property-detail.component';
import { SearchlistComponent } from './searchlist/searchlist.component';
import { StaticPageComponent } from './static-page/static-page.component';
import { CareersComponent } from './careers/careers.component';
import { BecomeOwnerComponent } from './becomeowner/becomeowner.component';
import { TopLivingAreasComponent } from './top-living-areas/top-living-areas.component';
import { UploadDocsAndRefsComponent } from './tenant-dashboard/upload-docs-and-refs/upload-docs-and-refs.component';
import { InvestorComponent } from './investor/investor.component';
import { EditprofileComponent } from './editprofile/editprofile.component';
import { CatalogueComponent } from './becomeowner/catalogue/catalogue.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { FaqComponent } from './faq/faq.component';
import { TeamComponent } from './team/team.component';
import { ResetComponent } from './auth/reset.component';
import { PageNotFoundComponent } from './404/pagenotfound.component';
import { CsatComponent } from './csat/csat.component';
import { NewHomeComponent } from './new-home/new-home.component';
import { TenantsComponent } from './tenants/tenants.component';
import { PropertyManagerComponent } from './property-manager/property-manager.component';
import { LeadershipComponent } from './leadership/leadership.component';

import { TenantDbComponent } from './new-tenant-dashboard/tenantdb.component';
import { FiveRingsComponent } from './partnerships/fiverings/fiverings.component';
import { AbhiHomesComponent } from './partnerships/abhihomes/abhihomes.component';
import { AgserHomesComponent } from './partnerships/agserhomes/agserhomes.component';
import { YgcComponent} from './partnerships/ygc/ygc.component';
import { EqaroComponent } from './partnerships/eqaro/eqaro.component';

const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      {path: '' , pathMatch: 'full' , redirectTo: '/home'},
      // {path: '/' ,component: NewHomeComponent},
      {path: 'referrals', component: ReferralsComponent},
      {path: 'profile/owner',component: OwnerDashboardComponent},
      {path: 'update', component: UpdateProfileComponent},
      {path: 'roomalloc', component: RoomAllocAndProfileComponent},
      {path: 'roomAllocAndUpdateProfile', component: RoomAllocAndProfileComponent},
      {path: 'profile/tenant',component: TenantDashboardComponent},
      {path: 'profile/tenant/:ten_db_component', component:TenantDashboardComponent},
      {path: 'premiumproperties', component: GoldenPropertiesComponent},
      {path: 'premiumproperties/:city', component: GoldenPropertiesComponent},
      {path: 'property/:property_id', component: PropertyDetailComponent },
      {path: ':city/properties-for-rent/:location/:gender', component: SearchlistComponent},
      {path: ':city/properties-for-rent/:location', component: SearchlistComponent},
      {path: ':city/properties-for-rent', component: SearchlistComponent},
      {path: ':city/rooms-for-rent', component: SearchlistComponent},
      {path: ':city/rooms-for-rent/:sharetype', component: SearchlistComponent},
      {path: ':city/premium-properties-for-rent/', component: GoldenPropertiesComponent},
      {path: ':city/premium-properties-for-rent/:locality', component: GoldenPropertiesComponent},
      {path: 'page/:id/:details', component: StaticPageComponent},
      {path: 'careers/:id', component: CareersComponent},
      {path: 'careers', component: CareersComponent},
      {path: 'toplivingareas', component: TopLivingAreasComponent},
      {path: 'uploaddocsandrefs', component: UploadDocsAndRefsComponent},
      {path: 'investor/information', component: InvestorComponent},
      {path: 'becomeanowner' , component: BecomeOwnerComponent},
      {path: 'editprofile', component: EditprofileComponent},         
      {path: 'pmscatalogue' , component: CatalogueComponent},
      {path: 'testimony', component: TestimonialsComponent},
      {path: 'faq', component: FaqComponent},
      {path: 'ourteam' , component : TeamComponent},      
      {path: 'feedback/showcsatform/:pid/:uid/:tid', component: CsatComponent},   
      {path: 'home', component: NewHomeComponent},   
      {path: 'tenant', component: TenantsComponent},
      {path: 'leadership', component: LeadershipComponent},
      {path: 'propertymanager', component: PropertyManagerComponent},
      {path: 'tenant/dashboard' , component: TenantDbComponent},
      {path: 'partnerships/fiverings', component: FiveRingsComponent},
      {path: 'partnerships/abhihomes', component: AbhiHomesComponent},
      {path: 'partnerships/agserhomes', component: AgserHomesComponent},
      {path: 'partnerships/ygc', component: YgcComponent},
      {path: 'partnerships/eqaro' , component: EqaroComponent}
    ]
  },
  { path: 'login', component: LoginComponent},
  { path: 'login/activate/:acttoken' , component: LoginComponent },
  { path: 'auth/reset' , component: ResetComponent },
  
  
];

@NgModule({

  imports: [
    RouterModule.forRoot(routes),

  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
